import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, message, Modal, Upload } from 'antd'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, switchNum1, formatNum } from '@/utils/utils'
import { ITreeSelectData, useDictModel } from '@/views/base/dict/dictModel'
import { useAssetsEntryDetailsModel } from './assetsEntryDetailsModel'
import { ISCMAssetsEntryFormFields } from '../../assetsEntryTypes'
import useGlobalModel from '@/model/globalModel'
import { YhAuth } from '@/components/auth/YhAuth'
import { debounce } from 'lodash'
import { assetsEntryService } from '../../assetsEntryService'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import FontIcon from '@/components/YhIcon'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { fileDownload } from '@/utils/exportFile'
import { UploadFile } from 'antd/lib/upload/interface'
import { YHDetailNav } from '@/components/YHDetailNav'
import { useOrgModel } from '@/views/base/organization/orgModel'
import { globalPrompt } from '@/components/message'
import { applyListService } from '@/views/apply/applyList/applyListService'
import { Image } from 'antd';

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const {
        editFormVal,
        addFormVal,
        buttonControl,
        saveBtnLoading,
        saveBtn,
        applyList, 
        setApplyList,
        setPrint,
        insertSDc,
        updateSDc,
        getSDcDetailOne,
        updateEditFormVal,
        updateAddFormVal,
        resetEditCatch,
        resetAddCatch,
        verifyGoods,
        setSaveBtnLoading,
    } = useAssetsEntryDetailsModel()
    const { selectedNavId, replaceNav, findNav } = useNavModel()
    const { getSelectedDictOne } = useDictModel(() => [])
    const { getOrgTreeSelect } = useOrgModel(() => [])

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('2-1-1') && resetAddCatch()
            !findNav('2-1-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //编辑时， 没有缓在调用详情接口    //回显对应门店核算单位的实体
    useEffect(() => {
        if (mode !=='add') {
                getSDcDetailOne(id)
                return
        }
    }, [mode])
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        if(changedValues['applyCode']){
            saveCache({ note:applyList.find((item) => item.value === changedValues['applyCode'])?.name ?? ''})
        }else{
        saveCache(changedValues)
    }
    }
    const focusApplyCode = async () => {
        if (!(mode === 'add' ?addFormVal.department: editFormVal.department)) {
            globalPrompt('message', { text: '请先选择申请部门哦！', type: 'warning' })
            return
        }
        const searchParams = {
            isUse:0,
            department:mode === 'add'?addFormVal.department: editFormVal.department,
            status: "assets-apply-status.pass",
            pageSize: 50,
            pageNum: 1,
            typeCode:'assets-apply-type.purchase'
        }
        let { retData } = await applyListService.page(searchParams);
        const { records, ...pg } = retData;
        let option=records.map((item)=>{
            return{
                label:item.code+'('+item.supplierName+')',
                value:item.code,
                name:item.supplierName,
            }
        })
        setApplyList(option);    
    }
    //机构选中
    const onDepartmentChange = (value: string, node: ITreeSelectData) => {
        node && saveCache({ departmentName: node.title,department: node.value, })
    }
    
    //表单提交
    const onSubmit = () => {
        if (!verifyGoods(mode)) return
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    val.md5 = file?.uid
                    val.fileName = file?.name
                } else {
                    val.md5 = ''
                    val.fileName = ''
                }
                val.fileList = null
                val.typeName =val.typeCode? getSelectedDictOne(DictCodeEnmu.ASSETS_PROCURE).find((item) => item.value ===val.typeCode)?.label:''
                val.sourceName = val.source? getSelectedDictOne(DictCodeEnmu.ASSETS_SOURCE).find((item) => item.value ===val.source)?.label:''
                val.invoiceStatusName = val.invoiceStatus? getSelectedDictOne(DictCodeEnmu.ASSETS_INVOICE_STATUS).find((item) => item.value ===val.invoiceStatus)?.label:''
                val.invoiceTypeName = val.invoiceTypeCode? getSelectedDictOne(DictCodeEnmu.ASSETS_INVOICE_TYPE).find((item) => item.value ===val.invoiceTypeCode)?.label:''
                mode === 'edit'
                    ? updateSDc(val)
                    : insertSDc(val).then((res) => {
                            setSaveBtnLoading(false)
                              replaceNav(selectedNavId, '2-1')
                      })
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_ED_SAVE}>
            {mode=='add'&&<Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveBtnLoading}
                onClick={debounce(() => {
                    onSubmit()
                }, 500)}
            >
                {saveBtnLoading ? '保存中' : '保存'}
            </Button>}
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_P_ED_BACK}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    replaceNav(selectedNavId, '2-1')
                    setSaveBtnLoading(false)
                }}
            >
                返回
            </Button>
            </YhAuth>
        </>
    )

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购单号',
                fieldName: 'code',
                disable: true,
                span: 4,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '供应商名称',
                fieldName: 'supplierName',
                rules: [{ required: true, message: '请输入组合名称' }],
                span: 4,
            },
            {
                type:mode=='add'?FormItemTypeEnum.TreeSelect:FormItemTypeEnum.Input,
                fieldLabel: '申请部门',
                fieldName:mode=='add'?'department':'departmentName',
                span: 4,
                onTreeSelectChange:onDepartmentChange,
                treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                rules: [{ required: true, message: '请选择申请部门' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '申请单号',
                fieldName: 'applyCode',
                options: applyList,
                onSelectFocus:focusApplyCode,
                // rules: [{ required: true, message: '请选择申请单号' }],
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购说明',
                fieldName: 'note',
                labelCol:{ span: 3 },
                span:8
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '采购来源',
                fieldName: 'source',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_SOURCE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系人',
                fieldName: 'contacts',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '联系电话',
                fieldName: 'phone',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '采购类型',
                fieldName: 'typeCode',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_PROCURE),
                span: 4,
            },
            {
                type:  FormItemTypeEnum.Input,
                fieldLabel: '采购实体',
                fieldName: 'bentityCode',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '用途',
                fieldName: 'uses',
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '发票状态',
                fieldName: 'invoiceStatus',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_INVOICE_STATUS),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '发票类型',
                fieldName: 'invoiceTypeCode',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_INVOICE_TYPE),
                span: 4,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购时间',
                fieldName: 'createTime',
                span: 4,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '采购员',
                fieldName: 'createUser',
                placeholder: '自动生成',
                disable: true,
                span: 4,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 8,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            disabled={mode=='look'}
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file) => {
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                }
                                // return isType && isLt20M
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )
                            }}
                        >
                            <Button icon={<UploadOutlined />}>选择文件上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'departmentName',
                hidden: true,
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '采购类型名称',
            //     fieldName: 'typeName',
            //     hidden: true,
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '采购来源名称',
            //     fieldName: 'sourceName',
            //     hidden: true,
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '发票状态名称',
            //     fieldName: 'invoiceStatusName',
            //     hidden: true,
            // },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: '发票类型名称',
            //     fieldName: 'invoiceTypeName',
            //     hidden: true,
            // },
        ],
    }

    const poFromConfig: IYhFormBox<ISCMAssetsEntryFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'add' ?addFormVal: editFormVal ,
        onChange,
        boxs: [baseFormItem],
        disabled: mode!=='add',
    }

    return (
        <>
            <YHDetailNav title={`${mode === 'edit' ? '编辑' : '新增'}`} btns={action} style={{ marginBottom: '8px' }} />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
